import script from "./DeadlineFloorsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DeadlineFloorsTable.vue?vue&type=script&setup=true&lang=js"

import "./DeadlineFloorsTable.vue?vue&type=style&index=0&id=195e987e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-195e987e"]])

export default __exports__